// @ts-nocheck
// oxlint-disable no-unused-vars
import type {
	ApiResponseOfBlogArticleDto,
	ApiResponseOfBlogArticlePageDto,
	BlogArticleRequest,
} from "../types";
import { apiFetch, type ApiResponse } from "@/api/fetch";

/** Auto-generated file. Do not edit. */

/**
 * DELETE `/blog/${id}`
 */
export const deleteApiBlogById = ({
	id,
}: {
	/** @format uuid */
	id: string;
}) =>
	apiFetch<ApiResponse<null>>({
		uri: `blog/${id}`,
		method: "DELETE",
	});

/**
 * GET `/blog`
 */
export const getApiBlog = (query: {
	/** @format int32 */
	limit: number;
	/** @format int32 */
	offset: number;
}) =>
	apiFetch<ApiResponseOfBlogArticlePageDto>({
		uri: "blog",
		method: "GET",
		query: query,
	});

/**
 * GET `/blog/${id}`
 */
export const getApiBlogById = ({
	id,
}: {
	/** @format uuid */
	id: string;
}) =>
	apiFetch<ApiResponseOfBlogArticleDto>({
		uri: `blog/${id}`,
		method: "GET",
	});

/**
 * POST `/blog`
 */
export const postApiBlog = (data: BlogArticleRequest) =>
	apiFetch<ApiResponseOfBlogArticleDto>({
		uri: "blog",
		method: "POST",
		body: data,
	});

/**
 * PUT `/blog/${id}`
 */
export const putApiBlogById = (
	{
		id,
	}: {
		/** @format uuid */
		id: string;
	},
	data: BlogArticleRequest,
) =>
	apiFetch<ApiResponse<null>>({
		uri: `blog/${id}`,
		method: "PUT",
		body: data,
	});
